import React, { useCallback, useEffect, useRef, useState } from "react";
import {useImage} from "../ImageContext/ImageContext";
import {useMouseController} from "../temp/useMouseController";

//-----------------------------------------------------------------
export function Magnifier(props) {
  //-----------------------------------------------------------------

  //#region [VALUES] 

  const {
    settings
  } = props;

  const { is_full_size, is_magnifier_held, magnifier_size } = settings || {};

  const { width, height, withContext, image } = useImage();
  const ref_frame = useRef(null);

  const [ ref_magnify     , setRefMagnify     ] = useState( null );
  const [ context_magnify , setContextMagnify ] = useState( null );

  const ref_held = useRef(false);

  const setMagnifyRefNode = useCallback(node => {
    if (node !== null) {
      const context = node.getContext("2d")
      setContextMagnify( context );
      setRefMagnify( node );
    }
  }, []);

  const pointer = useMouseController({
    target: {current: ref_magnify},
    // Listen on window, compute relative against overlayRef
    listenOn: "document",
    rafThrottle: true,
    enablePointerCapture: true,
    includeGlobalCoords: false,
  });

  const draw = useCallback( _draw, [pointer, withContext] );

  //#endregion

  //#region [STYLES]
  
  const fit_page = {
    maxWidth  : '100%',
    maxHeight : '100%',
  }

  const fit_width = {
    width  : '100%',
    height : '',
  }

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    if( context_magnify == null ) return;

    if (ref_frame.current != null) return;
    ref_frame.current = requestAnimationFrame(() => {
      ref_frame.current = null;
      draw();
    });
    return () => {
      if (ref_frame.current != null) {
        cancelAnimationFrame(ref_frame.current);
        ref_frame.current = null;
      }
    };
  }, [draw, context_magnify, pointer]);

  useEffect(() => {
    if( context_magnify == null ) return;

    if( false ) {}
    else if(  pointer.primaryDown &&  ref_held.current ) {
      ref_held.current = false;
      context_magnify.clearRect(0, 0, width, height )
    }
    else if(  pointer.primaryDown && !ref_held.current ) {
      ref_held.current = true;
    }
    else if( !pointer.primaryDown &&  is_magnifier_held ) {
    }
    else if( !pointer.primaryDown && !is_magnifier_held ) {
      ref_held.current = false;
      context_magnify.clearRect(0, 0, width, height )
    }
  }, [pointer.primaryDown, context_magnify, width, height, is_magnifier_held]);

  //#endregion

  //#region [EVENTS]


  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  async function _draw() {
    //-----------------------------------------------------------------
    if( !context_magnify ) return;

    if( !(pointer.primaryDown && ref_held.current) ) {
      return;
    }

    const mag_width  = ((400*magnifier_size)/100)||1;
    const mag_height = ((200*magnifier_size)/100)||1;

    const x_conv = width  / ref_magnify.clientWidth  ;
    const y_conv = height / ref_magnify.clientHeight ;

    let xx = parseInt(((pointer.x||0 ) * x_conv));
    let yy = parseInt(((pointer.y||0 ) * y_conv));
    
    const  width_half = parseInt( mag_width  / 2 )
    const height_half = parseInt( mag_height / 2 )
    const left_img = parseInt( xx -  width_half );
    const  top_img = parseInt( yy - height_half );
    const left_mag = parseInt( xx - mag_width   );
    const  top_mag = parseInt( yy - mag_height  );

    // === DRAW ===
    context_magnify.clearRect(0, 0, width, height );
    context_magnify.beginPath();

    context_magnify.drawImage(image, left_img, top_img, mag_width, mag_height, left_mag, top_mag, mag_width*2, mag_height*2 );
    context_magnify.rect( left_mag, top_mag, mag_width*2, mag_height*2 );

    context_magnify.stroke();
    context_magnify.restore();
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( width == null ) return null
    
    return (
      <canvas
        ref    = { setMagnifyRefNode }
        width  = {width }
        height = {height}
        style  = { {
          position  : 'absolute' ,
          top       : 0          ,
          left      : 0          ,
          zIndex    : 30,
          pointerEvents: "none",
          ...(is_full_size ? fit_width : fit_page)
        } }
      />
    )
  }

  //#endregion

  return display();
};
